// App.js
import './App.css';
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LandingPage from './landing/LandingPage';
import TechnologyPage from './blog/TechnologyPage';
import AboutPage from './about/AboutPage';
import RepoMain from './my_repo/RepoMain';
import RepoEntry from './my_repo/RepoEntry';

import { marked } from 'marked';
import hljs from 'highlight.js';
import 'highlight.js/styles/github.css';

marked.setOptions({
  highlight: function (code, language) {
    const validLanguage = hljs.getLanguage(language) ? language : 'plaintext';
    return hljs.highlight(validLanguage, code).value;
  },
  langPrefix: 'hljs language-'
});

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/technology/*" element={<TechnologyPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/repos/*" element={<RepoMain />} />
          <Route path="/repo-entry/:repoName/*" element={<RepoEntry />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;